/* eslint-disable no-unused-vars */
import { Divider, IconButton, ListItemText, MenuItem } from "@mui/material";
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";

import CentralLoadingIndicator from "../CentralLoadingIndicator/CentralLoadingIndicator";
import { GvCustomMenu } from "../../styles/styledComponents";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { IWellnessPlanDetails } from "../../services/wellness-plan/wellness-plan.interface";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import MemberCardIcon from "../Icons/MemberCardIcon";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { PAGES_PATH } from "../../navigation/params";
import { fromUnixToFormattedVisitdateStr, hasEndDateElapsed, isDateWithinFiveDays, isWithinPast30Days } from "../../utils/unix-timestamp";
import { useFetchWellnessPlanByPetId } from "../../services/wellness-plan/wellness-plan.service";
import { useNavigate } from "react-router-dom";
import { userActivityLogger } from "../../utils/mixpanel";
import { OVERDUE_STATUSES, OverdueStatus } from "../../config/params";

export const getPlanOverdueText = (overdueStatus: string, isRenewUnsuccessful?: boolean, isCancelledRenewUnsuccessful?: boolean, isPlanEndingInFiveDays?:boolean) => {
  switch (overdueStatus) {
  case OVERDUE_STATUSES.OVERDUE:
    return "Wellness Plan Payment Overdue";
  case OVERDUE_STATUSES.PAUSED:
    return isPlanEndingInFiveDays?
      "Payment Overdue":
      isRenewUnsuccessful ? "Renewal Unsuccessful" :
        "Wellness Plan Paused";
  case OVERDUE_STATUSES.CANCELLED:
    return isCancelledRenewUnsuccessful ? "Renewal Unsuccessful" :"Wellness Plan Canceled for Non-Payment";
  default:
    return "";
  }
};

interface IPlanCard{
  petList : IPetItemResponse[];
  handlePetChange?: (petId: string, category: string) => void;
  petData: IPetItemResponse;
  isSubscriptionBenefitAvailable?: boolean;
  planOverdueStatus: OverdueStatus | null;
  setIsLoading?: (loading: boolean) => void;
}

export const getWellnessMemberList = (petDataList: IPetItemResponse[], currentPetId?: string)=>{
  const pet = petDataList.filter((pet) => pet?.items?.wellnessPlanStatus && pet.id !== currentPetId);

  return pet;
};

export const WellnessMemberPlanCardOld = (props: IPlanCard) => {
  const { petList, petData, handlePetChange, isSubscriptionBenefitAvailable, planOverdueStatus, setIsLoading } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { getWellnessPlanByPetId, data, loading } = useFetchWellnessPlanByPetId();
  const [petWellnessDetails, setWellnessPetDetails] = useState<IWellnessPlanDetails>();
  const [sortedPetList, setSortedPetList] = useState<IPetItemResponse[]>([]);
  const endDate = petWellnessDetails?.endDate;
  const startDate = petWellnessDetails?.startDate;
  const hasPlanEndDateElapsed = typeof endDate === "string" ? hasEndDateElapsed(endDate) : false;
  const isPlanWithinPast30Days = typeof startDate === "string" ? isWithinPast30Days(startDate) : false;
  const isPaymentOverdueNotice =
    planOverdueStatus === OVERDUE_STATUSES.PAUSED &&
    typeof endDate === "string" &&
    isDateWithinFiveDays(endDate);
  const isPausedNonNotice = planOverdueStatus === OVERDUE_STATUSES.PAUSED && !isPaymentOverdueNotice;
  const overdueBannerClassName = (() => {
    if (
      planOverdueStatus === OVERDUE_STATUSES.CANCELLED ||
      hasPlanEndDateElapsed ||
      (isPlanWithinPast30Days && petWellnessDetails?.renewalStatus) ||
      isPausedNonNotice
    ) {
      return "text-white bg-red-4";
    }
    return "text-red-4 bg-red-3";
  })();


  const handlePetMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleManagePlan = (petId: string, petName: string) => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICKS_MANAGE_PLAN,
      { pet_id: petId,
        pet_name: petName,
        referred_from: "wellness_page",
      });
    navigate(`${PAGES_PATH.MANAGE_PLAN}?id=${petId}`);
  };

  useEffect(()=>{
    petData && getWellnessPlanByPetId(petData.id);
  }, [petData]);

  useEffect(()=>{
    petList && setSortedPetList(getWellnessMemberList(petList, petData.id));
  }, [petList]);

  useEffect(()=>{
    if (data) {
      setWellnessPetDetails(data?.wellnessPlanDetails[0]);
    }
  }, [data]);

  useEffect(()=>{
    setIsLoading && setIsLoading(loading);
  }, [loading]);

  if (loading) {
    return <CentralLoadingIndicator />;
  }


  return (
    <div className={`relative bg-violet-1 ${planOverdueStatus ? "rounded-t-xl" : "rounded-xl shadow-lg"} overflow-hidden
      p-6`}>
      <MemberCardIcon className="absolute top-0 right-0 object-cover h-[8rem]" />
      <IconButton className="!absolute !top-1.5 !right-2 !cursor-pointer !text-black"
        id="petEdit-button" aria-haspopup="true"
        aria-controls={open ? "petEdit-menu" : undefined}
        aria-expanded={open ? "true" : undefined} onClick={handlePetMenu}>
        <MoreHorizIcon color="secondary" />
      </IconButton>
      <GvCustomMenu
        autoFocus={false}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        anchorEl={anchorEl} open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "appointment-button",
        }}
        classes={{ list: "!p-0" }}
        className="!max-h-[20rem]"
      >
        <MenuItem disabled={!isSubscriptionBenefitAvailable}
          onClick={()=>planOverdueStatus === OVERDUE_STATUSES.CANCELLED ? null : handleManagePlan(petData.id, petData.name)}
        >
          <ListItemText sx={{ color: planOverdueStatus === OVERDUE_STATUSES.CANCELLED ? "#908E8D" : "" }}>Manage Plan</ListItemText>
        </MenuItem>
        <Divider className="w-full !m-0" />
        {sortedPetList.map((pet, index) => (
          <MenuItem sx={{
            borderBottom: index !== sortedPetList.length - 1 ? "1px solid #F4EFEB" : "none",
          }}
          onClick={() => handlePetChange && handlePetChange(pet.id, "Wellness_Plan")}
          key={pet.id}
          >
            <ListItemText>{`View ${pet.name}'s plan`}</ListItemText>
          </MenuItem>
        ))}
      </GvCustomMenu>
      <div className="flex flex-col items-center gap-1">
        <div className="text-2xl text-white font-semibold capitalize">
          {petData.name}’s GoodPet+ Plan
        </div>
        {(planOverdueStatus) && petWellnessDetails &&
        <div className={`w-full text-center text-sm font-semibold rounded py-0.5 ${overdueBannerClassName} z-10`}>
          {getPlanOverdueText(planOverdueStatus,
            hasEndDateElapsed(petWellnessDetails?.endDate),
            (isWithinPast30Days(petWellnessDetails?.startDate) && petWellnessDetails.renewalStatus),
            isPaymentOverdueNotice)
          }
        </div>}
        {
          (planOverdueStatus !== OVERDUE_STATUSES.PAUSED && planOverdueStatus !== OVERDUE_STATUSES.CANCELLED) &&
            <div className="text-sm text-white font-extralight">
              <span className="font-semibold">Active:</span> {petWellnessDetails && fromUnixToFormattedVisitdateStr(+petWellnessDetails?.startDate)} - Present
            </div>
        }
        {planOverdueStatus === OVERDUE_STATUSES.PAUSED ?
          <div className="text-xs text-white">
        Please pay overdue invoices to resume benefits
          </div>:
          planOverdueStatus === OVERDUE_STATUSES.CANCELLED ?
            <div className="text-xs text-white text-center w-56">
        Please reach out to your hospital team
        for further assistance
            </div>:
            <div className="text-xs text-white">
        Next billing on {petWellnessDetails && fromUnixToFormattedVisitdateStr(+petWellnessDetails?.nextBillingDate)}
            </div>
        }
      </div>
    </div>
  );
};

export default WellnessMemberPlanCardOld;
